@if (state.roundState.phase === AppPhase.TableClosed && state.worker?.accessLevel !== WorkerAccessLevel.Supervisor) {
    <app-supervisor-panel [message]="'Scan supervisor card to open table'" [showBackButton]="false" />
} @else if (supervisorLogoutMode) {
    <app-supervisor-panel [message]="'Scan supervisor card to log out'" (backClicked)="cancelLogoutClicked.emit()" />
} @else if (state.supervisorState) {
    @switch (state.supervisorState.subPhase) {
        @case (SupervisorSubPhase.WaitingForSupervisor) {
            <app-supervisor-panel
                [inverseColors]="true"
                [message]="'Scan supervisor card to continue'"
                (backClicked)="cancelActionClicked.emit($event)"
            />
        }

        @case (SupervisorSubPhase.ConfirmAction) {
            @switch (state.supervisorState.selectedAction) {
                @case (DealerConsoleAction.CloseTable) {
                    <app-supervisor-panel
                        [title]="'Closing ' + (state.supervisorState.selectedGameType | gameLabel)"
                        [message]="'Scan supervisor card to confirm changes and continue'"
                        (backClicked)="cancelActionClicked.emit($event)"
                    />
                }

                @case (DealerConsoleAction.ChangeShoe) {
                    <app-supervisor-panel
                        [title]="'Voiding game and change shoe'"
                        [message]="'Scan supervisor card to confirm changes and continue'"
                        (backClicked)="cancelActionClicked.emit($event)"
                    />
                }

                @case (DealerConsoleAction.ChangeResult) {
                    @if (state.supervisorState.changedGameResult) {
                        <app-supervisor-panel
                            [title]="'Result changed'"
                            [message]="'Scan supervisor card to confirm changes and continue'"
                            (backClicked)="cancelActionClicked.emit($event)"
                        />
                    }
                }
            }
        }

        @case (SupervisorSubPhase.ConfirmGameSelection) {
            <app-supervisor-panel
                [title]="'Selected game: ' + (state.supervisorState.selectedGameType | gameLabel)"
                [message]="'Scan supervisor card to confirm the selection and continue'"
                (backClicked)="cancelActionClicked.emit($event)"
            />
        }
    }
}
